<template>
  <div class="flex overflow-hidden h-screen font-sans text-on-surface bg-background relative">
    <router-view />
    
    <!-- Background Atmospheric Effect -->
    <div class="fixed inset-0 -z-10 pointer-events-none">
      <div class="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]"></div>
      <div class="absolute bottom-1/4 right-1/4 w-[600px] h-[600px] bg-secondary/5 rounded-full blur-[150px]"></div>
    </div>
  </div>
</template>

<script>
import { userStore } from '@/store/user'

export default {
  internal_name: 'App',
  async mounted() {
    if (localStorage.getItem('theme') === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    
    if (localStorage.getItem('access_token')) {
      await userStore.fetchUser()
    }
  }
};
</script>